import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Helper function to get XSRF-TOKEN from cookies
export function getCookie(name: string) {
  const regex = new RegExp("(^| )" + name + "=([^;]+)");
  const match = regex.exec(document.cookie);
  return match ? decodeURIComponent(match[2]) : "";
}
